import { checkModifyRoomConstraints, createModifyRoomUpdate } from '@module/helpers/centrifuge/messageUpdates';
import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import { isModifyRoomMessage, type ModifyRoomMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class ModifyRoomHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<ModifyRoomMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isModifyRoomMessage(payload);
  }

  handle(payload: ModifyRoomMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;
    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setPlayInfo(createModifyRoomUpdate(payload, context.playInfo));

    // 제약 조건 체크 (getOutOfRoom이 있을 때만)
    if (context.getOutOfRoom && typeof context.isLogin === 'boolean' && typeof context.isAdult === 'boolean') {
      const constraints = checkModifyRoomConstraints(
        payload,
        context.playInfo,
        context.isLogin,
        context.isAdult,
        context.siteMode,
      );

      if (constraints.shouldExit && constraints.message) {
        context.getOutOfRoom(constraints.message);
      } else if (constraints.shouldRefetch) {
        context.retryLivePlay?.();
      }
    }
  }
}
